import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { setVizLoading } from '../../../../store/visualizerSlice';
import ProductGroupStep from '../ProductGroupStep/ProductGroupStep';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './BathPlumbing.module.css';

const COLLECTIONS = ['Woodhurst', 'Kayra', 'Lahara', 'Ashlyn', 'Cassidy'];

export default function BathPlumbing({
    surfaceName = 'Bath Plumbing',
    stepIndex,
    room = '',
    onViewAllApplied,
    onNext,
    onPrevious
}) {
    const dispatch = useDispatch();
    const [collection, setCollection] = useState(COLLECTIONS[0]);

    const handleSelect = useCallback((product) => {
        const chamViz = document.getElementById('chamViz');
        if (!chamViz || !product.id) return;

        dispatch(setVizLoading(true));

        chamViz.applyByFilter(
            product.id,
            '',
            function(newSel) {
                if (this.name === 'Faucet') return newSel;
                return this.sel;
            },
            true
        );
    }, [dispatch]);

    return (
        <div className={styles.wrapper}>
            <StepNavigation
                title="Bathroom Plumbing"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={onViewAllApplied}
            />

            <div className={styles.filterRow}>
                <select
                    className={styles.dropdown}
                    value={collection}
                    onChange={(e) => setCollection(e.target.value)}
                >
                    {COLLECTIONS.map(c => (
                        <option key={c} value={c}>{c}</option>
                    ))}
                </select>
                <div className={styles.collectionThumbWrap}>
                    <img
                        src={`/bath-plumbing/collections/${collection.toLowerCase()}.jpg`}
                        alt={collection}
                        className={styles.collectionThumb}
                        onError={(e) => {
                            e.currentTarget.style.display = 'none';
                            const fallback = e.currentTarget.nextSibling;
                            if (fallback) fallback.style.display = 'flex';
                        }}
                        onLoad={(e) => {
                            e.currentTarget.style.display = 'block';
                            const fallback = e.currentTarget.nextSibling;
                            if (fallback) fallback.style.display = 'none';
                        }}
                    />
                    <div className={styles.collectionFallback}>{collection}</div>
                </div>
            </div>

            <div className={styles.productArea}>
                <ProductGroupStep
                    title=""
                    stepName="BathPlumbing"
                    seriesId="9788"
                    surfaceName={surfaceName}
                    stepIndex={stepIndex}
                    room={room}
                    onViewAllApplied={onViewAllApplied}
                    onNext={onNext}
                    onPrevious={onPrevious}
                    hideNav
                    onProductSelect={handleSelect}
                    nameFilter={collection}
                />
            </div>
        </div>
    );
}

BathPlumbing.propTypes = {
    surfaceName: PropTypes.string,
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
